module.exports = __webpack_public_path__ + "assets/img/3.9433374c.jpg";